module.exports = __webpack_public_path__ + "Amodto_logo.png";